import shower from '../assets/icons/ico/shower.ico';
import clear from '../assets/icons/ico/clear.ico';
import hail from '../assets/icons/ico/hail.ico';
import heavyRain from '../assets/icons/ico/heavyRain.ico';
import lightCloud from '../assets/icons/ico/lightCould.ico';
import lightRain from '../assets/icons/ico/lightRain.ico';
import sleet from '../assets/icons/ico/sleet.ico';
import snow from '../assets/icons/ico/snow.ico';
import thunderstrom from '../assets/icons/ico/thunderstrom.ico';
import heavyCloud from '../assets/icons/ico/heavyCould.ico';

const WEATHER_ICO = {
  s: shower,
  c: clear,
  h: hail,
  hc: heavyCloud,
  hr: heavyRain,
  lc: lightCloud,
  lr: lightRain,
  sl: sleet,
  sn: snow,
  t: thunderstrom
};

export default WEATHER_ICO;

